import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import LandingPage from './LandingPage.jsx'
import Support from './Support'
import ResultsPage from './ResultsPage';
import LegacyResultsPage from './LegacyResultsPage.jsx';
import VideoUploadPage from './VideoUploadPage';
import PhotosListPage from './PhotosListPage';
import MyResultsPage from './MyResultsPage.jsx';
import SharePreviewPage from './SharePreviewPage.jsx';
import CheckoutPage from './CheckoutPage.jsx';
import CheckoutSuccessPage from './CheckoutSuccessPage.jsx';
import PrivacyPolicyPage from './PrivacyPolicyPage.jsx';
import TermsPage from './TermsPage.jsx';


const App = () => {

  return (
    <>
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/support" element={<Support />} />
          <Route path="/result/:docId" element={<LegacyResultsPage />} />
          <Route path="/videos/:docId" element={<ResultsPage />} />
          <Route path="/share/:shareId" element={<SharePreviewPage />} />
          <Route path="/upload-video/:docId" element={<VideoUploadPage />} />
          <Route path="/photos" element={<PhotosListPage />} />
          <Route path="/my-results" element={<MyResultsPage />} />
          <Route path="/profile" element={<MyResultsPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccessPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/eula" element={<TermsPage />} />
        </Routes>
      </div>
    </Router>
    </>
  );

};

export default App;
